import actions from '../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {useEffect, useRef, useState} from 'react';
import PersonInfoCard from '../../common/components/PersonInfoCard/PersonInfoCard';
import {useHistory} from 'react-router-dom';
import _ from 'lodash';
import Table from '../../common/components/ItemTable/v2/Table';
import CustomInput from '../../common/components/CustomInput/CustomInput';
import Search from '../../assets/icons/Search';
import './CreateAttention.scss';
import Chip from '../../common/components/Chip/v2/Chip';
import Button from '../../common/components/Button/Button';
import RemovableList from '../../common/components/RemovableList/RemovableList';
import Loader from '../../common/components/Loader/Loader';
import Loading from '../../common/components/Loading/Loading';
import CustomAlert from '../../common/components/Alert/CustomAlert';

const SecondStep = (props) => {
        const {
            name,
            title,
            switchOfUser,
            getAllMedicalServices,
            allMedicalServices,
            getAllMedicalServicesState,
            affiliateSelected,
            affiliateData,
            approveAttention,
            setAttentionForCreate,
            attentionForCreate,
            branchesProviders,
            allMedicalServicesConfig,
            setListConfig,
            cleanListConfig,
            branches,
            attentionsSelected,
            setAttentionsSelected,
            userInfo,
            showSidebar,
            onFinish,
        } = props;

        const history = useHistory();

        const [currentPage, setCurrentPage] = useState(0);
        const [allChecked, setAllChecked] = useState(false);

        const pageQuantity = Math.ceil(allMedicalServices?.totalCount / allMedicalServicesConfig.size);

        const isInitialMount = useRef(true);

        const listData = [
            // {title: '', component: (medicalService) => checkButton(medicalService), width: '20%'},
            {id: 'DESCRIPCIÓN', title: 'Descripción', att: 'medicalServiceDescription', flex: 2, sort: true},
            {id: 'CÓDIGO', title: 'Código', att: 'medicalServiceCode', center: true, centerTitle: true, sort: true},
            {id: 'RUBRO', title: 'Rubro', att: 'medicalServiceCategory', sort: true},
        ];

        const listDataHeaders = [
            // {title: '', component: () => checkButtonHeaders(), width: '5%', center: true, allRows: true},
            {title: 'DESCRIPCIÓN', att: 'medicalServiceDescription', width: '30%', sort: true},
            {title: 'CÓDIGO', att: 'medicalServiceCode', width: '20%', center: true, centerTitle: true, sort: true},
            {title: 'RUBRO', att: 'medicalServiceCategory', width: '40%', sort: true},
        ];

        const tagNames = {
            medicalServiceName: 'Descripción',
            medicalServiceCode: 'Código',
            medicalServiceCategory: 'Rubro',
        };
        const filters = [
            'Laboratorio', 'Imagenes', 'Consultas', 'Practicas y Estudios', 'Otros',
        ];

        const [search, setSearch] = useState('');
        const [searchTag, setSearchTag] = useState('medicalServiceName');
        const [category, setCategory] = useState('');
        const [provider, setProvider] = useState(branches?.find((branch) => branch.providerId === attentionForCreate.salesforceProviderId)?.fullName);
        const [branch, setBranch] = useState(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
        const [medicalServices, setMedicalServices] = useState([]);

        const [showHelper, setShowHelper] = useState(false);

        const handleHelper = () => {
            setShowHelper(!showHelper);
        };

        const handleCategorySelect = (e) => {
            setCategory(category === e.target.value ? '' : e.target.value);
            setAllChecked(false);
        };

        const handleSearch = () => {
            const searchTags = {...allMedicalServicesConfig.searchTags, [searchTag || 'medicalServiceName']: search};

            setListConfig({
                list: 'allMedicalServicesConfig',
                config: {search: search, searchTags, page: 0},
            });
            setCurrentPage(0);
            getAllMedicalServices();

            setSearch('');
        };

        useEffect(() => {
            switchOfUser('Prestaciones');
            switch (userInfo.role.name) {
                case 'ADMIN':
                    setProvider(branches?.find((branch) => branch.providerId === attentionForCreate.salesforceProviderId)?.fullName);
                    setBranch(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
                    break;
                case 'PROVIDER_ADMIN':
                    setProvider(userInfo.salesforceProviderName);
                    setBranch(branchesProviders?.find((branch) => branch.branchId === attentionForCreate.salesforceBranchId)?.fullName);
                    break;
                case 'PROVIDER_USER':
                case 'PROVIDER_USER_QUOTER':
                    setProvider(userInfo.salesforceProviderName);
                    setBranch(userInfo.salesforceBranchName);
                    break;
                default:
                    break;
            }
            cleanListConfig('allMedicalServicesConfig');
            setCurrentPage(allMedicalServicesConfig?.page ?? 1);
            // eslint-disable-next-line
        }, []);

        useEffect(() => {
            if (category !== '') {
                setListConfig({
                    list: 'allMedicalServicesConfig',
                    config: {category: category, page: 1},
                });
                setCurrentPage(1);
                getAllMedicalServices();
            }
            // eslint-disable-next-line
        }, [category]);

        useEffect(() => {
            if (!isInitialMount.current || allMedicalServicesConfig === undefined) {
                const activeAffiliate = affiliateData.find((x) => x.status === 'Activo');
                const planName = activeAffiliate?.plans?.[0]?.name || '';
                setListConfig({
                    list: 'allMedicalServicesConfig',
                    config: {page: currentPage, planName: planName},
                });
                getAllMedicalServices();
            }
            isInitialMount.current = false;
            setAllChecked(false);
            // eslint-disable-next-line
        }, [currentPage]);

        useEffect(() => {
            if (currentPage > pageQuantity) setCurrentPage(pageQuantity);
            // eslint-disable-next-line
        }, [allMedicalServices]);

        useEffect(() => {
            if (getAllMedicalServicesState.success) {
                setMedicalServices(allMedicalServices?.results.map((row) => ({id: row.medicalServiceId, ...row})));
            }
        }, [getAllMedicalServicesState]);

        const deleteSearchTag = (tag) => {
            const searchTags = _.omit(allMedicalServicesConfig?.searchTags, [tag]);

            setListConfig({
                list: 'allMedicalServicesConfig',
                config: {search: search, searchTags},
            });
            getAllMedicalServices();
        };


        const resetFilters = () => {
            cleanListConfig('allMedicalServicesConfig');
            const searchTags = [];
            const activeAffiliate = affiliateData.find((x) => x.status === 'Activo');
            const planName = activeAffiliate?.plans?.[0]?.name || '';
            setListConfig({
                list: 'allMedicalServicesConfig',
                config: {search: '', searchTags, planName: planName},
            });
            setCurrentPage(1);
            setCategory('');
            getAllMedicalServices();
        };

        const checkIfAlreadyIn = (medicalServices) => {
            const medicalServicesToSelect = [];
            medicalServices.forEach((medicalService) => {
                // I check if it is already in attentions selected in order to keep the count attribute when changing steps
                const alreadyIn = attentionsSelected.find((x) => x.medicalServiceId === medicalService.id);
                medicalServicesToSelect.push(alreadyIn ? alreadyIn : medicalService);
            });
            setAttentionsSelected(medicalServicesToSelect);
        };


        const approveMultiple = () => {
            const body = {
                ...attentionForCreate,
                medicalServicesIds: attentionsSelected.map((x) => x.medicalServiceId),
                document: affiliateSelected.searchTag === 'document' ? affiliateSelected.affiliate : null,
                affiliateNumber: affiliateSelected.searchTag === 'affiliateNumber' ? affiliateSelected.affiliate : null,
            };
            setAttentionForCreate(body);
            approveAttention(_.omit(body, ['salesforceProviderId']));
            onFinish();
        };

        const handleSelect = (newSelection) => {
            const oldSelected = attentionsSelected.filter((sRow) => !medicalServices.find((row) => sRow.id === row.medicalServiceId));
            // These are the values from the current page
            const value = medicalServices.filter((row) => newSelection.includes(row.id));
            checkIfAlreadyIn([...oldSelected, ...value]);
        };

        const handleOnRowClick = (row) => {
            attentionsSelected.find((x) => x.medicalServiceId === row.medicalServiceId) ? setAttentionsSelected(attentionsSelected.filter((x) => x.medicalServiceId !== row.medicalServiceId)) : setAttentionsSelected([...attentionsSelected, row]);
        };

        return (
            <div className={'v2-step-div w-80'}>
                <div className={'v2-create-attention-title-div'}>
                    <h3 className={'h3 v2-c-text-title'}>Prestaciones</h3>
                    <p className={'body-1 c-text-subtitle'}>Seleccione las prestaciones que desee</p>
                </div>
                {affiliateData.length > 0 && affiliateData[0] ? (
                    <PersonInfoCard
                        fullName={affiliateData[0].medicalCoverage
                            ? `${affiliateData[0].fullName} - ${affiliateData[0].medicalCoverage}`
                            : affiliateData[0].fullName}
                        attributes={[
                            affiliateSelected.searchTag === 'document'
                                ? `DNI: ${affiliateData[0].documentNumber}`
                                : `Credencial: ${affiliateData[0].affiliateNumber}`,
                            `Prestador: ${provider}`,
                            `Sede: ${branch}`
                        ]}
                    />
                ) : (
                    <div>
                        {setTimeout(() => window.location.reload(), 0)}
                    </div>
                )}
                {attentionsSelected && <RemovableList buttonText={'Borrar todas'} buttonOnClick={() => setAttentionsSelected([])} title={'Prestaciones seleccionadas'} noElementsText={'No seleccionaste ninguna prestación'}
                                                      attributeToDisplayFromItem={'medicalServiceDescription'} items={attentionsSelected} onRemove={(item) => handleOnRowClick(item)}/>}
                <div className={'v2-second-step-table-container'}>
                    <div className={'v2-second-step-table-tools-container'}>
                        <div className={'v2-second-step-table-input-chip-container'}>
                            <form className={'second-step-input-form'} onSubmit={(e) => {
                                e.preventDefault();
                                handleSearch();
                            }}>
                                <CustomInput
                                    placeholder={`Buscar prestación...`}
                                    leftSlot={<Search width={'14px'} height={'14px'}/>}
                                    leftSlotOnClick={handleSearch}
                                    value={search}
                                    onChange={(value) => setSearch(value)}
                                />
                            </form>
                            <div className={'chip-container'}>
                                {allMedicalServicesConfig?.searchTags && Object.keys(allMedicalServicesConfig?.searchTags).map((key) =>
                                    <Chip
                                        key={key}
                                        text={'Prestación' + ': ' + allMedicalServicesConfig?.searchTags[key]}
                                        deleteOnClick={() => {
                                            deleteSearchTag(key);
                                        }}
                                    />,
                                )
                                }
                            </div>
                            <div>
                                <Button onClick={resetFilters} size={'small'}>Limpiar filtros</Button>
                            </div>
                        </div>
                        <div className={'input-filter-container'}>
                            {filters.map((filter) => {
                                return (
                                    <>
                                        <input
                                            type='radio'
                                            value={filter.toUpperCase()}
                                            name={filter.slice(0, 4)}
                                            className='subtitle-3 c-text-subtitle'
                                            onChange={(e) => handleCategorySelect(e)}
                                            checked={category === filter.toUpperCase()}
                                        />{filter}
                                    </>
                                );
                            })}
                        </div>
                    </div>
                    <div className={'table-container'}>
                    {getAllMedicalServicesState.success ?
                        <Table rows={medicalServices} attributes={listData} includeCheckbox={true}
                               rowCount={allMedicalServices?.totalCount}
                               pageSize={allMedicalServicesConfig.size} currentPage={currentPage}
                               selectedRows={attentionsSelected}
                               onSelectRow={handleSelect}
                               noRowsMessage={'No se encontraron prestaciones'}
                               onRowClick={handleOnRowClick}
                               onPageSizeChange={(value) => setCurrentPage(value)}
                               onPageChange={(value) => setCurrentPage(value)}/> :
                        getAllMedicalServicesState.loading?<Loader width={'80px'} height={'80px'} />:
                            <CustomAlert text={'atenciones' || String(getAllMedicalServicesState.error)} severity='error' />
                    }
                    </div>
                </div>
                <Button size={'medium'} onClick={approveMultiple}
                        disabled={attentionsSelected.length === 0}>Consultar</Button>
            </div>
        );
    }
;

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    allMedicalServices: state.home.allMedicalServices,
    getAllMedicalServicesState: state.home.getAllMedicalServicesState,
    affiliateSelected: state.home.affiliateSelected,
    affiliateData: state.home.affiliates,
    attentionForCreate: state.home.attentionForCreate,
    branchesProviders: state.home.branchesProviders,
    branches: state.home.branches,
    allMedicalServicesConfig: state.home.allMedicalServicesConfig,
    attentionsSelected: state.home.attentionsSelected,
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    getAllMedicalServices: () => dispatch(actions.home.getAllMedicalServicesRequest()),
    approveAttention: (body) => dispatch(actions.home.approveAttentionRequest(body)),
    setAttentionForCreate: (attention) => dispatch(actions.home.setAttentionForCreate(attention)),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    cleanListConfig: (list) => dispatch(actions.home.cleanListConfig(list)),
    setAttentionsSelected: (attentionsSelected) => dispatch(actions.home.setAttentionsSelected(attentionsSelected)),
});

SecondStep.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    allMedicalServices: PropTypes.object,
    getAllMedicalServicesState: PropTypes.object,
    affiliateSelected: PropTypes.object,
    affiliateData: PropTypes.array,
    branchesProviders: PropTypes.array,
};
export default connect(mapStateToProps, mapDispatchToProps)(SecondStep);
